// components/Products/UpdateMRPModal.js
import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Spinner } from "reactstrap";

const UpdateMRPModal = ({ isOpen, toggle, product, onUpdate }) => {
  const [mrp, setMrp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (product) {
      setMrp(product.regularunitprice || "");
      setError("");
    }
  }, [product]);

  const validateMrp = () => {
    if (!mrp.trim()) {
      setError("MRP is required");
      return false;
    }

    const mrpValue = parseFloat(mrp);
    if (isNaN(mrpValue) || mrpValue < 0) {
      setError("MRP must be a valid positive number");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateMrp()) return;

    setLoading(true);
    try {
      await onUpdate(mrp);
      toggle();
    } catch (error) {
      console.error("Failed to update MRP:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!product) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Update Product
        {/* <div className="mt-1">
          <small className="text-muted">{product.productname}</small>
        </div> */}
      </ModalHeader>
      <ModalBody>
        {/* <div className="mb-3">
          <div className="d-flex align-items-center mb-3">
            {product.imagelink && (
              <img
                src={product.imagelink}
                alt={product.productname}
                className="rounded me-3"
                style={{ width: "60px", height: "60px", objectFit: "cover" }}
              />
            )}
            <div>
              <h6 className="mb-0">{product.productname}</h6>
              <small className="text-muted">{product.productbrand} • {product.size}</small>
            </div>
          </div>

          <div className="mb-3 mt-2">
            <div className="row">
             
              <div className="col-md-6">
                <div className="mb-2">
                  <small className="text-muted d-block">Current MRP</small>
                  <h5 className="text-primary mb-0 mt-1">৳{product.mrp}</h5>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <FormGroup>
          <Label for="mrp">Price (৳) *</Label>
          <div className="input-group">
            <span className="input-group-text">৳</span>
            <input
              type="number"
              id="mrp"
              className={`form-control ${error ? 'is-invalid' : ''}`}
              value={mrp}
              onChange={(e) => {
                setMrp(e.target.value);
                if (error) setError("");
              }}
              placeholder="Enter new MRP"
              min="0"
              step="0.01"
            />
          </div>
          {error && <div className="invalid-feedback d-block">{error}</div>}

        </FormGroup>

        {/* <div className="alert alert-warning mt-3">
          <i className="fas fa-exclamation-triangle me-2"></i>
          <strong>Note:</strong> Updating MRP will affect all customers immediately.
        </div> */}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={loading || !mrp}
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Updating...
            </>
          ) : "Update"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateMRPModal;